import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const Marcas = () => {
  return (
    <div class="listado">
        <h2 className='tituloAccion'>Marcas</h2>
        <TableContainer>
            <Table sx={{minWidth: 500}} size="small" aria-aria-label='a dense table'>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align='center'><a href='../IngresoMarcas/Ingreso'>Ingreso</a></TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell align='center'><a href='../IngresoMarcas/BajaModificaciones'>Bajas/Modificaciones</a></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </div>
  )
}

export default Marcas